<template>
  <v-app>
    <v-img
      contain
      max-height="200"
      class="pink--text"
      :src="require('../assets/virtuaalijono.svg')"
    ></v-img>
    <div v-if="tooMuchSlots" style="font-size: 48px">
      <v-card-text fill-height class="narrow-content">
        <v-card-title class="layout align-center fill-height margin-block">
          <h1 class="killswitch-header">Pilotti päättynyt</h1>
        </v-card-title>
        <p class="killswitch-detail">Virtuaalijono on tämän päivän osalta täynnä</p>
      </v-card-text>
    </div>
    <div v-if="!shopOpen() && !tooMuchSlots " class="text-center">
      <v-card-text fill-height class="narrow-content">
        <v-card-title class="layout align-center fill-height margin-block">
          <h1>Virtuaalijono käytettävissä klo 15 - 18 välisenä aikana</h1>
        </v-card-title>
        <v-card-actions class="narrow-content">
          <v-spacer />
          <v-btn
                  text
                  color="#00B0EE"
                  width="100%"
                  class="margin-block"
                  @click="gotoInfo()"
          >Lisätietoja</v-btn>
        </v-card-actions>
      </v-card-text>
    </div>
    <div v-if="shopOpen() && !tooMuchSlots" class="text-center">
      <v-form id="inputForm" v-model="valid">
        <v-card-title class="layout align-center fill-height margin-block">
          <h1>Tervetuloa Tukkijoen virtuaalijonoon!</h1>
        </v-card-title>
        <v-card-text fill-height class="narrow-content">
          <div class="attention">
            <h3 class="queue-time-header">Arvioitu jonotusaika</h3>
            <div class="queue-time-value">{{ queueTime }} min</div>
          </div>
          <v-card-text class="margin-block">
            <p>
              Asetu jonoon ilmoittamalla puhelinnumerosi ja ryhmäsi koko. Saat tekstiviesteinä varmistuksen jonoon
              asettumisesta ja vuoron lähestymisestä.
            </p>
          </v-card-text>
          <v-text-field
            align-center
            label="Puhelinnumero"
            v-model="phoneNumber"
            :rules="phoneRules"
            required
            outline
            class="margin-block"
            type="tel"
            placeholder="040..."
            validate-on-blur
          />
          <v-select
            outline
            flat
            class="margin-block"
            label="Ryhmän koko"
            v-model="groupSize"
            :items="items"
            type="number"
            value="1"
          />
          <v-checkbox
            v-model="checkbox"
            :rules="checkboxRules"
            label="Hyväksyn että puhelinnumeroni tallennetaan pilotin ajaksi"
            required
            class="margin-block"
          />
          <div v-if="errorMessage !== null" class="error-message">{{ errorMessage }}</div>
          <v-card-actions class="narrow-content">
            <v-spacer />
            <v-btn
              depressed
              @click="addToQueue()"
              color="#00ADEE"
              :disabled="!valid"
              width="100%"
              class="white--text margin-block"
            >Liity jonoon</v-btn>
          </v-card-actions>
          <v-card-actions class="narrow-content">
            <v-spacer />
            <v-btn
              text
              color="#00B0EE"
              width="100%"
              class="margin-block"
              @click="gotoInfo()"
            >Lisätietoja</v-btn>
          </v-card-actions>
        </v-card-text>
      </v-form>
    </div>
  </v-app>
</template>

<script>
import { getQueueLength } from '../APIService';
import 'es6-promise/auto';

import { isWithinRange, isAfter } from 'date-fns';
import { isMobilePhone } from 'validator';
import _ from 'lodash';

const APIService = require('../APIService.js');

import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'Signup',
  components: {},
  computed: {
    ...mapGetters(['queueTime', 'queueSlots']),
    tooMuchSlots: function() {
      const lastReservedSlot = this.queueSlots[this.queueSlots.length - 1];
      const lastSlotTime = _.get(lastReservedSlot, 'loadTime', 0);
      return isAfter(lastSlotTime, new Date('2019-08-24T15:00:00.000Z').getTime());
    }
  },
  beforeMount: function() {
    this.refreshQueueTime();
  },
  data() {
    return {
      shopOpen: function() {
        return isWithinRange(new Date(), new Date('2019-08-24T11:45:00.000Z'), new Date('2019-08-24T15:00:00.000Z'));
      },
      valid: false,
      groupSize: 1,
      phoneNumber: '',
      phoneRules: [
        v => isMobilePhone(v, 'fi-FI') || 'Virheellinen puhelinnumero',
      ],
      checkbox: false,
      checkboxRules: [v => v.toString() === 'true' || 'Hyväksy numeron tallennus liittyäksesi jonoon.'],
      items: [1, 2, 3, 4, 5, 6],
      errorMessage: null,
    };
  },
  methods: {
    ...mapActions(['refreshQueueTime', 'setDetails', 'setSlot']),
    addToQueue: async function() {
      try {
        // eslint-disable-next-line
        const response = await APIService.addToQueue({ group: this.groupSize, phone: this.phoneNumber });
        if (response.status === 400) {
          this.errorMessage = 'Puhelinnumero on jo jonossa';
          return;
        } else if (response.status !== 200){
          this.errorMessage = 'Jonotusjärjestelmä ei saavutettavissa. Koita myöhemmin uudelleen.';
          return;
        }
        this.errorMessage = null;
        const { time, ID } = response.data;
        this.setDetails({ phone: this.phoneNumber, groupSize: this.groupSize });
        this.setSlot({ id: ID, time });
        this.$router.push({ path: 'queue' });
      } catch (error) {
        // eslint-disable-next-line
        alert(error);
      }
    },
    gotoInfo: function() {
      this.$router.push({ path: 'info' });
    },
  },
};
</script>

<style>
.center-button > button {
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.queue-time-header {
  text-transform: uppercase;
  color: #00b0ee;
}
  .error-message {
    width: 100%;
    color: #ff5252;
  }

  .killswitch-header {
    margin: 40px 0;
    text-align: center;
    width: 100%;
  }

  .killswitch-detail {
    text-align: center;
    font-size: 24px;
  }
</style>
